import React from "react";
import "./HierarchicalSidebar.css";

const HierarchicalSidebar = ({
    content,
    title = "Hijerarhija dalekovoda",
}) => {
    return (
        <div className="hierarchical-sidebar">
            <div className="sidebar-header">
                <span className="sidebar-title">{title}</span>
            </div>

            <div className="sidebar-content">
                <div className="sidebar-card">{content}</div>
            </div>
        </div>
    );
};

export default HierarchicalSidebar;